
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import { CancelButton, SubmitButtonModal } from '../../../components/buttons';
import { UpdateStaffScheduleLock} from '../actions/UserActions';
import React from 'react';
import Dialog from 'material-ui/Dialog';
import SmallLoader from '../../../img/small-loader.gif';
import { renderDateField } from '../../../components/reduxFields';
import moment from 'moment';

const validate = (values) => {
  const errors = {};

   if (!values.schedulerLockedDate || values.schedulerLockedDate.trim() === '') {
    errors.schedulerLockedDate = 'Please enter lock date';
  }
  return errors;
};


class SchedulerLockedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staffId: props.staffId ? props.staffId : null,
      staffName: props.staffName ? props.staffName : null,
      noteId: null,
      deleteModal : false,
      schedulerLockedDate: props.schedulerLockedDate ? props.schedulerLockedDate : null,
    }
    this.filter = {
      sort_Column: '',
      sort_Order: '',
      searchText: '',
    };
    
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.staffLockStatus && nextProps.staffLockStatus !== this.props.staffLockStatus) {
      this.handleCloseAndReset();
    }
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };
    
  handleCloseAndReset = () => {
    this.props.closeAndResetDialog();
  }

  handleClose = () => {
    this.props.closeDialog();
  }
  onSubmitHandler(formProps) {
    this.props.UpdateStaffScheduleLock(this.state.staffId, moment(formProps.schedulerLockedDate).format('YYYY-MM-DD') + 'T' + moment(formProps.schedulerLockedDate).format('HH:mm:ss'));
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
         {!this.state.deleteModal && <Dialog
          className="custom_modal"
          title={'Lock scheduler for ' + this.state.staffName}
          modal={false}
          open={true}
          //actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" >
                <div className="row">
                  <div className="col-sm-12 require mt-30">
                    <Field
                        name="schedulerLockedDate"
                        placeholder="Date"
                        component={renderDateField}
                        openToYearSelection={true}
                        locale="en-US"
                        //minDate={this.state.doj}
                        //maxDate={new Date()}
                        selected={this.state.schedulerLockedDate}
                        onDateChange={this.onDateChange} />
                       <small className="redfont font12">Please note that once the schedule is locked, no appointments can be created or modified on or before the lock date.</small>
                  </div>
                </div>               
                <div className="row">
                  <div className="col-sm-12 pt20 btn_rt">
                    <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
                      <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Save" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.user.loading,
    staffLockStatus: state.user.staffLockStatus,
  };
};

SchedulerLockedModal = reduxForm({
  form: 'SchedulerLockedModal', // a unique identifier for this form
  validate,
})(SchedulerLockedModal);

export default connect(mapStateToProps, { UpdateStaffScheduleLock })(SchedulerLockedModal);



// WEBPACK FOOTER //
// ./src/modules/users/User/SchedulerLocked_Modal.js